<template>
  <div class="nv-grid-row nv-grid-multiline" v-if="topics && topics?.length && product">
    <div class="nv-grid-col nv-grid-col-12 nv-px-0">
      <h4>
        {{ $t('frequent_topics') }}
      </h4>
      <p class="nv-mb-0">
        {{ $t('expore_kb') }}
      </p>
    </div>
    <div class="nv-grid-col nv-grid-col-12 nv-px-0">
      <ul class="topics-list nv-d-grid">
        <nuxt-link
          v-for="(topic, idx) of topics"
          :key="idx"
          :to="localePath(`/support/products/${product.slug}/${topic?.slug}`)"
        >
          <li

            class="topics-item"
          >
            <div class="nv-d-flex nv-flex-column">
              <div class="nv-d-flex nv-align-items-center">
                <!-- <img :src="topic.icon" :alt="topic.name" class="nv-mr-1"> -->
                <h6 class="nv-mb-0">
                  {{ topic.name }}
                </h6>
              </div>
            </div>
          </li>
        </nuxt-link>
      </ul>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { useProductStore } from '~/store/product';

// ---------------------------------------
// Props
// ---------------------------------------

// ---------------------------------------
// Hooks
// ---------------------------------------
const localePath = useLocalePath();
const productStore = useProductStore();

const { product } = storeToRefs(productStore);

const { data: topics, error, status } = await useAsyncData('getSupportProductTopics', () => getTopics());

async function getTopics() {

  return product.value?.supportSections
    .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())) as any;
}

</script>

<style lang="scss" scoped>
/*
* Mixes
*/
@import '@nuiverse/core/src/style/_utils';
@import '@nuiverse/core/src/style/mixins/_breakpoints';

.articles-list {
  color: inherit;
  list-style: none;

  a {
    color: inherit;
  }
}

.topics-list {
  column-gap: 24px;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  row-gap: 24px;

  li {
    background: var(--nv-theme);
    border-radius: 8px;
    padding: 16px;

    &:hover {
      box-shadow: 0 0 4px 4px rgba(0, 99, 180, 0.12);
      cursor: pointer;
    }

    img {
      height: 40px;
      margin-right: 8px;
      width: 40px;
    }
  }
}

</style>
